import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { ModalConfirmacaoService } from 'src/app/shared/services/modal-confirmacao.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { IUsuarioAdmin } from '../../data/usuario-admin';
import { UsuarioAdminService } from '../../services/usuario-admin.service';

@Component({
  selector: 'app-list-usuarios-admin',
  templateUrl: './list-usuarios-admin.component.html',
  styleUrls: ['./list-usuarios-admin.component.scss']
})
export class ListUsuariosAdminComponent {
  @Input() usuariosAdmin: IUsuarioAdmin[] = [];
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  @Output() mudouPagina = new EventEmitter<number>();
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() recarregarListagem = new EventEmitter();
  ERoleAdminString = ERoleAdminString;
  constructor(
    private readonly modalConfirmacao: ModalConfirmacaoService,
    private readonly usuariosAdminService: UsuarioAdminService,
    private readonly toastService: ToastService
  ) {}

  public toogleUsuarioAdminStatus(medicoId: string, status: boolean): void {
    const textoStatus = status ? 'desativar' : 'ativar';

    this.modalConfirmacao
      .abrirModalConfirmacao({
        mensagem: `Tem certeza que deseja ${textoStatus} o usuário admin?`
      })
      .subscribe((resposta) => {
        if (!resposta) return;

        if (status) {
          this.usuariosAdminService.desativarUsuarioAdmin(medicoId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            // if (resposta.isSucceed) {
            this.recarregarListagem.emit();
            // }
          });
        } else {
          this.usuariosAdminService.ativarUsuarioAdmin(medicoId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            // if (resposta.isSucceed) {
            this.recarregarListagem.emit();
            // }
          });
        }
      });
  }
}
